// Card #1943 — a venue watermark layer behind the board's content, the same
// "single source of truth shared by CSS render + editor" pattern logoSizes.js
// already established for logo slot sizing (#1640): the theme editor's
// slider bounds and the board's actual CSS output both call the SAME clamp
// helpers here, so they cannot drift apart the way two independently
// hand-copied numeric ranges could.
//
// The three defaults are lifted verbatim from card #1928's approved WEC demo
// page (demo/scoreboard/p1.html on card_1928_scoreboard_demo_pages), which is
// the hand-tuned reference this card is turning into a configurable theme
// field rather than a baked-in constant:
//
//   opacity: 0.085;
//   background-size: auto 72%;
//   background-position: center 46%;
export const DEFAULT_WATERMARK_OPACITY = 0.085;
export const DEFAULT_WATERMARK_SIZE = 72;
export const DEFAULT_WATERMARK_VERTICAL_POSITION = 46;

// Bounds. Opacity is deliberately capped well under 1: a watermark strong
// enough to compete with real content defeats AC4's "cannot paint over"
// intent even though the z-index ordering alone would still hold — a value
// this low keeps the mark a background texture, never a foreground rival.
export const MIN_WATERMARK_OPACITY = 0.02;
export const MAX_WATERMARK_OPACITY = 0.5;

// Size and vertical position are both percentages (background-size:auto{n}%
// / background-position:center{n}%) — generous ranges since a venue's mark
// image can be any aspect ratio, but still bounded so a bad value can't blow
// the image up past anything recognizable as a watermark.
export const MIN_WATERMARK_SIZE = 20;
export const MAX_WATERMARK_SIZE = 150;

export const MIN_WATERMARK_VERTICAL_POSITION = 0;
export const MAX_WATERMARK_VERTICAL_POSITION = 100;

function clamp(value, min, max, fallback) {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(max, Math.max(min, n));
}

// Non-finite/absent input (an old theme saved before this card, a malformed
// value) falls back to the default rather than rendering NaN into a CSS
// value or clamping garbage into a boundary number — same "fall back to
// default on bad input" contract logoHeightPx already uses.
export function watermarkOpacity(value) {
  return clamp(value, MIN_WATERMARK_OPACITY, MAX_WATERMARK_OPACITY, DEFAULT_WATERMARK_OPACITY);
}

export function watermarkSizePercent(value) {
  return clamp(value, MIN_WATERMARK_SIZE, MAX_WATERMARK_SIZE, DEFAULT_WATERMARK_SIZE);
}

export function watermarkVerticalPositionPercent(value) {
  return clamp(
    value,
    MIN_WATERMARK_VERTICAL_POSITION,
    MAX_WATERMARK_VERTICAL_POSITION,
    DEFAULT_WATERMARK_VERTICAL_POSITION
  );
}
